import React from "react";
import colors from "theme/config/colors";
import Button, { Theme } from "theme/components/buttons/Button";

const DarkGreenOutlinedButton = (props: any) => {
    const theme: Theme = {
        color: colors.darkGreen,
        borderColor: colors.darkGreen,
        hover: {
            color: colors.white,
            backgroundColor: colors.darkGreen,
        },
        disabled: {
            opacity: "30%",
        },
    };

    return <Button {...props} theme={theme} />;
};

export default DarkGreenOutlinedButton;
